module.exports = __webpack_public_path__ + "static/demos-logo-c078390aa80ca833fb378f6ad7220410.svg";